export default [
  {
    path: '/koreksi/cleansing',
    redirect: '/koreksi/cleansing',
    name: 'koreksiCleansing',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'koreksiCleansingIndex',
        component: () => import('@/views/koreksi/cleansing/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'koreksi-cleansing',
          pageTitle: 'Cleansing',
          breadcrumb: [
            { text: 'Koreksi' },
            { text: 'Data Inventarisasi', active: true },
          ],
        },
      },
      {
        path: '/koreksi/cleansing/tambah',
        name: 'koreksiCleansingTambah',
        component: () => import('@/views/koreksi/cleansing/Tambah.vue'),
        meta: {
          action: 'Buat',
          resource: 'koreksi-cleansing',
          pageTitle: 'Cleansing',
          breadcrumb: [
            { text: 'Koreksi' },
            { text: 'Data Inventarisasi' },
            { text: 'Tambah', active: true },
          ],
        },
      },
      {
        path: '/koreksi/cleansing/detail/:id',
        name: 'koreksiCleansingDetail',
        component: () => import('@/views/koreksi/cleansing/Ubah.vue'),
        meta: {
          action: 'Buat',
          resource: 'koreksi-cleansing',
          pageTitle: 'Cleansing',
          breadcrumb: [
            { text: 'Koreksi' },
            { text: 'Data Inventarisasi' },
            { text: 'Detail', active: true },
          ],
        },
        props: true,
      },
      // {
      //   path: '/koreksi/cleansing/:id',
      //   name: 'koreksiTambah',
      //   component: () => import('@/views/koreksi/Tambah.vue'),
      //   meta: {
      //     action: 'Buat',
      //     resource: 'koreksi',
      //     pageTitle: 'Koreksi',
      //     breadcrumb: [
      //       {
      //         text: 'Koreksi',
      //       },
      //       {
      //         text: 'Cleansing',
      //         active: true,
      //       },
      //     ],
      //   },
      //   props: true
      // },
      // {
      //   path: '/koreksi/validasi/:id',
      //   name: 'koreksiValidasi',
      //   component: () => import('@/views/koreksi/Validasi.vue'),
      //   meta: {
      //     action: 'Validasi',
      //     resource: 'koreksi',
      //     pageTitle: 'Pengembalian Data',
      //     breadcrumb: [
      //       {
      //         text: 'Koreksi',
      //       },
      //       {
      //         text: 'Pengembalian Data',
      //         active: true,
      //       },
      //     ],
      //   },
      //   props: true
      // },
    ],
  },
]

// export default [
//   {
//       path: '/formulir/permohonan-pengukuran/pendaftaran',
//       redirect: '/formulir/permohonan-pengukuran/pendaftaran',
//       name: 'formulirPermohonanPengukuranPendaftaran',
//       component: () => import('@/views/NestedRoute.vue'),
//       children: [
//           {
//               path: '',
//               name: 'formulirPermohonanPengukuranPendaftaranIndex',
//               component: () => import('@/views/formulir/permohonanPengukuran/pendaftaran/Index2.vue'),
//               meta: {
//                   action: 'Lihat',
//                   resource: 'formulir-permohonanPengukuran-pendaftaran',
//                   pageTitle: 'Pendaftaran',
//                   breadcrumb: [
//                       {
//                           text: 'Formulir',
//                       },
//                       {
//                           text: 'Permohonan Pengukuran',
//                       },
//                       {
//                           text: 'Pendaftaran',
//                           active: true,
//                       },
//                   ],
//               }
//           },
//           {
//               path: '/formulir/permohonan-pengukuran/pendaftaran/tambah',
//               name: 'formulirPermohonanPengukuranPendaftaranTambah',
//               component: () => import('@/views/formulir/permohonanPengukuran/pendaftaran/Tambah2.vue'),
//               meta: {
//                   action: 'Buat',
//                   resource: 'formulir-permohonanPengukuran-pendaftaran',
//                   pageTitle: 'Pendaftaran Pengukuran',
//                   breadcrumb: [
//                       {
//                           text: 'Formulir',
//                       },
//                       {
//                           text: 'Permohonan Pengukuran',
//                       },
//                       {
//                           text: 'Pendaftaran',
//                       },
//                       {
//                           text: 'Tambah',
//                           active: true,
//                       },
//                   ],
//               },
//           },
//           {
//               path: '/formulir/permohonan-pengukuran/pendaftaran/ubah/:id',
//               name: 'formulirPermohonanPengukuranPendaftaranUbah',
//               component: () => import('@/views/formulir/permohonanPengukuran/pendaftaran/Ubah2.vue'),
//               meta: {
//                   action: 'Ubah',
//                   resource: 'formulir-permohonanPengukuran-pendaftaran',
//                   pageTitle: 'Ubah Pendaftaran',
//                   breadcrumb: [
//                       {
//                           text: 'Formulir',
//                       },
//                       {
//                           text: 'Permohonan Pengukuran',
//                       },
//                       {
//                           text: 'Pendaftaran',
//                       },
//                       {
//                           text: 'Ubah',
//                           active: true,
//                       },
//                   ],
//               },
//               props: route => {
//                   return {
//                       action: 'Ubah',
//                       id: route.params.id
//                   }
//               }
//           },
//           {
//               path: '/formulir/permohonan-pengukuran/pendaftaran/verifikasi/:id',
//               name: 'formulirPermohonanPengukuranPendaftaranVerifikasi',
//               component: () => import('@/views/formulir/permohonanPengukuran/pendaftaran/Ubah.vue'),
//               meta: {
//                   action: 'Verifikasi',
//                   resource: 'formulir-permohonanPengukuran-pendaftaran',
//                   pageTitle: 'Verifikasi Pendaftaran',
//                   breadcrumb: [
//                       {
//                           text: 'Formulir',
//                       },
//                       {
//                           text: 'Permohonan Pengukuran',
//                       },
//                       {
//                           text: 'Pendaftaran',
//                       },
//                       {
//                           text: 'Verifikasi',
//                           active: true,
//                       },
//                   ],
//               },
//               props: route => {
//                   return {
//                       action: 'Verifikasi',
//                       id: route.params.id
//                   }
//               }
//           },
//           {
//               path: '/formulir/permohonan-pengukuran/pendaftaran/detail/:id',
//               name: 'formulirPermohonanPengukuranPendaftaranDetail',
//               component: () => import('@/views/formulir/permohonanPengukuran/pendaftaran/Detail2.vue'),
//               meta: {
//                   action: 'Detail',
//                   resource: 'formulir-permohonanPengukuran-pendaftaran',
//                   pageTitle: 'Detail Pendaftaran',
//                   breadcrumb: [
//                       {
//                           text: 'Formulir',
//                       },
//                       {
//                           text: 'Permohonan Pengukuran',
//                       },
//                       {
//                           text: 'Pendaftaran',
//                       },
//                       {
//                           text: 'Detail',
//                           active: true,
//                       },
//                   ],
//               },
//               props: true
//           },
//       ]
//   }
// ]
